import {
	SET_ERROR_MESSAGE,
	SET_INITIAL_LOGIN_STATE,
	CHANGE_LOGIN_ID,
	CHANGE_PIN,
	CHANGE_OTP,
	SET_SOCIAL_LOGIN_USER_DETAIL,
	SET_AUTH_SUCCESS,
	UPDATE_ACTIVE_COURSE,
	SET_RESET_PATH,
	OTP_LOGIN,
	OTP_VERIFY,
	SET_COUNTRY,
	SET_USER_TYPE,
} from './userAuth.actionTypes';
import { setUserState } from './userAuth.utils';
import { getParameterByName, setCookie } from '../../utils/commonFunctions';

const loginInit = !!document.getElementById('txtLoginId')
	? document.getElementById('txtLoginId').value
	: '';
const paramLoginId = getParameterByName('loginId');

let admitad_uid = getParameterByName('admitad_uid');
if (!!admitad_uid) {
	setCookie('admitad_uid', admitad_uid, 30);
}
const initialLoginState = {
	loginId:
		localStorage.getItem('login_id') ||
		localStorage.getItem('loginId') ||
		(!!paramLoginId ? paramLoginId : loginInit),
	pin: !!localStorage.getItem('pin')
		? localStorage.getItem('pin')
		: !!getParameterByName('pin')
		? getParameterByName('pin')
		: '',
	courseId: '',
	step_one: false,
	success: false,
	returnPath: getParameterByName('return_path') || '/mydashboard',
	disableVerify: false,
	returnSearch: '',
	errorPanel: {
		panelClass: '',
		panelMsg: '',
	},
	token: '',
	loginType: '',
	loginOtp: '',
	userId: '',
	userName: '',
	otp: '',
	isInternational: false,
	login_type: '',
	userPhone: '',
	userEmail: '',
	newUser: false,
	supportEmail: 'info@steptest.in',
	supportPhone: '9789883344',
	resetState: false,
	userType: 'regular',
};

export const setLoginDetails = (state = initialLoginState, action = {}) => {
	switch (action.type) {
		case SET_INITIAL_LOGIN_STATE:
			return Object.assign({}, state, { ...action.payload, resetState: false });
		case CHANGE_LOGIN_ID:
			return Object.assign({}, state, { loginId: action.payload });
		case CHANGE_PIN:
			return Object.assign({}, state, { pin: action.payload });
		case CHANGE_OTP:
			return Object.assign({}, state, { otp: action.payload });
		case SET_ERROR_MESSAGE:
			return Object.assign({}, state, { errorPanel: action.payload });
		case UPDATE_ACTIVE_COURSE:
			return Object.assign({}, state, { courseId: action.payload });
		case SET_AUTH_SUCCESS:
			return Object.assign({}, state, {
				...setUserState(action.payload, state.loginId),
			});
		case SET_RESET_PATH:
			return Object.assign({}, state, { returnPath: action.payload });

		case OTP_LOGIN.SUCCESS:
			return Object.assign({}, state, {
				userId: action.payload.user_id,
				loginId: action.payload.login_id,
				loginType: action.payload.login_type,
			});
		case OTP_VERIFY.SUCCESS:
			console.log(action.payload);
			return Object.assign({}, state, { ...action.payload });
		case SET_COUNTRY:
			return Object.assign({}, state, { isInternational: action.payload });
		case SET_USER_TYPE:
			return Object.assign({}, state, { userType: action.payload });
		default:
			return state;
	}
};

const socialLoginDetails = {
	loginId: '',
	userToken: '',
	userName: '',
	photoUrl: '',
	socialDomain: '',
};

export const setSocialLoginUserDetail = (
	state = socialLoginDetails,
	action = {},
) => {
	switch (action.type) {
		case SET_SOCIAL_LOGIN_USER_DETAIL:
			return Object.assign({}, state, { ...action.payload });
		default:
			return state;
	}
};
